import { getEnvironmentSettings } from '@pb/services';

const { baseUrl } = getEnvironmentSettings();

export const baseUrls = {
    base: baseUrl,
    instructApp: `${baseUrl}/instruct-products`,
    propertiesApp: `${baseUrl}/properties`,
    paymentsApp: `${baseUrl}/payments`,
    antiForgeryTokenApi: `${baseUrl}/account/antiforgerytoken`,
};
